import forEach from 'lodash/forEach';

export const setCssVariablesToRoot = (
  variables: Record<string, string>,
) => {
  forEach(variables, (value, key) => {
    document.documentElement.style.setProperty(`--${ key }`, value);
  });
};
